export enum ContractStatus {
	to_do = 'to_do',
	in_progress = 'in_progress',
	completed = 'completed',
	expired = 'expired',
	canceled = 'canceled',
}

export enum ContractNotificationCategory {
	ContractCreated = 'contract_created',
	OrderLinked = 'order_linked',
	ContractCanceled = 'contract_canceled',
	ContractResumed = 'contract_resumed',
	ContractEdited = 'contract_edited',
	ContractExpired = 'contract_expired',
	ContractCompleted = 'contract_completed',
	OrderFromContractDelivered = 'order_from_contract_delivered',
	ContractExpiringSoon = 'contract_expiring_soon',
}
